export default "__VITE_ASSET___ETnwNLO__"